"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bandeiras = exports.dicionarioBandeiras = void 0;
var react_1 = __importDefault(require("react"));
var ad_svg_1 = __importDefault(require("../flags/1x1/ad.svg"));
var ae_svg_1 = __importDefault(require("../flags/1x1/ae.svg"));
var af_svg_1 = __importDefault(require("../flags/1x1/af.svg"));
var ag_svg_1 = __importDefault(require("../flags/1x1/ag.svg"));
var ai_svg_1 = __importDefault(require("../flags/1x1/ai.svg"));
var al_svg_1 = __importDefault(require("../flags/1x1/al.svg"));
var am_svg_1 = __importDefault(require("../flags/1x1/am.svg"));
var ao_svg_1 = __importDefault(require("../flags/1x1/ao.svg"));
var aq_svg_1 = __importDefault(require("../flags/1x1/aq.svg"));
var ar_svg_1 = __importDefault(require("../flags/1x1/ar.svg"));
var arab_svg_1 = __importDefault(require("../flags/1x1/arab.svg"));
var as_svg_1 = __importDefault(require("../flags/1x1/as.svg"));
var asean_svg_1 = __importDefault(require("../flags/1x1/asean.svg"));
var at_svg_1 = __importDefault(require("../flags/1x1/at.svg"));
var au_svg_1 = __importDefault(require("../flags/1x1/au.svg"));
var aw_svg_1 = __importDefault(require("../flags/1x1/aw.svg"));
var ax_svg_1 = __importDefault(require("../flags/1x1/ax.svg"));
var az_svg_1 = __importDefault(require("../flags/1x1/az.svg"));
var ba_svg_1 = __importDefault(require("../flags/1x1/ba.svg"));
var bb_svg_1 = __importDefault(require("../flags/1x1/bb.svg"));
var bd_svg_1 = __importDefault(require("../flags/1x1/bd.svg"));
var be_svg_1 = __importDefault(require("../flags/1x1/be.svg"));
var bf_svg_1 = __importDefault(require("../flags/1x1/bf.svg"));
var bg_svg_1 = __importDefault(require("../flags/1x1/bg.svg"));
var bh_svg_1 = __importDefault(require("../flags/1x1/bh.svg"));
var bi_svg_1 = __importDefault(require("../flags/1x1/bi.svg"));
var bj_svg_1 = __importDefault(require("../flags/1x1/bj.svg"));
var bl_svg_1 = __importDefault(require("../flags/1x1/bl.svg"));
var bm_svg_1 = __importDefault(require("../flags/1x1/bm.svg"));
var bn_svg_1 = __importDefault(require("../flags/1x1/bn.svg"));
var bo_svg_1 = __importDefault(require("../flags/1x1/bo.svg"));
var bq_svg_1 = __importDefault(require("../flags/1x1/bq.svg"));
var br_svg_1 = __importDefault(require("../flags/1x1/br.svg"));
var bs_svg_1 = __importDefault(require("../flags/1x1/bs.svg"));
var bt_svg_1 = __importDefault(require("../flags/1x1/bt.svg"));
var bv_svg_1 = __importDefault(require("../flags/1x1/bv.svg"));
var bw_svg_1 = __importDefault(require("../flags/1x1/bw.svg"));
var by_svg_1 = __importDefault(require("../flags/1x1/by.svg"));
var bz_svg_1 = __importDefault(require("../flags/1x1/bz.svg"));
var ca_svg_1 = __importDefault(require("../flags/1x1/ca.svg"));
var cc_svg_1 = __importDefault(require("../flags/1x1/cc.svg"));
var cd_svg_1 = __importDefault(require("../flags/1x1/cd.svg"));
var cefta_svg_1 = __importDefault(require("../flags/1x1/cefta.svg"));
var cf_svg_1 = __importDefault(require("../flags/1x1/cf.svg"));
var cg_svg_1 = __importDefault(require("../flags/1x1/cg.svg"));
var ch_svg_1 = __importDefault(require("../flags/1x1/ch.svg"));
var ci_svg_1 = __importDefault(require("../flags/1x1/ci.svg"));
var ck_svg_1 = __importDefault(require("../flags/1x1/ck.svg"));
var cl_svg_1 = __importDefault(require("../flags/1x1/cl.svg"));
var cm_svg_1 = __importDefault(require("../flags/1x1/cm.svg"));
var cn_svg_1 = __importDefault(require("../flags/1x1/cn.svg"));
var co_svg_1 = __importDefault(require("../flags/1x1/co.svg"));
var cp_svg_1 = __importDefault(require("../flags/1x1/cp.svg"));
var cr_svg_1 = __importDefault(require("../flags/1x1/cr.svg"));
var cu_svg_1 = __importDefault(require("../flags/1x1/cu.svg"));
var cv_svg_1 = __importDefault(require("../flags/1x1/cv.svg"));
var cw_svg_1 = __importDefault(require("../flags/1x1/cw.svg"));
var cx_svg_1 = __importDefault(require("../flags/1x1/cx.svg"));
var cy_svg_1 = __importDefault(require("../flags/1x1/cy.svg"));
var cz_svg_1 = __importDefault(require("../flags/1x1/cz.svg"));
var de_svg_1 = __importDefault(require("../flags/1x1/de.svg"));
var dg_svg_1 = __importDefault(require("../flags/1x1/dg.svg"));
var dj_svg_1 = __importDefault(require("../flags/1x1/dj.svg"));
var dk_svg_1 = __importDefault(require("../flags/1x1/dk.svg"));
var dm_svg_1 = __importDefault(require("../flags/1x1/dm.svg"));
var do_svg_1 = __importDefault(require("../flags/1x1/do.svg"));
var dz_svg_1 = __importDefault(require("../flags/1x1/dz.svg"));
var eac_svg_1 = __importDefault(require("../flags/1x1/eac.svg"));
var ec_svg_1 = __importDefault(require("../flags/1x1/ec.svg"));
var ee_svg_1 = __importDefault(require("../flags/1x1/ee.svg"));
var eg_svg_1 = __importDefault(require("../flags/1x1/eg.svg"));
var eh_svg_1 = __importDefault(require("../flags/1x1/eh.svg"));
var er_svg_1 = __importDefault(require("../flags/1x1/er.svg"));
var es_ct_svg_1 = __importDefault(require("../flags/1x1/es-ct.svg"));
var es_ga_svg_1 = __importDefault(require("../flags/1x1/es-ga.svg"));
var es_pv_svg_1 = __importDefault(require("../flags/1x1/es-pv.svg"));
var es_svg_1 = __importDefault(require("../flags/1x1/es.svg"));
var et_svg_1 = __importDefault(require("../flags/1x1/et.svg"));
var eu_svg_1 = __importDefault(require("../flags/1x1/eu.svg"));
var fi_svg_1 = __importDefault(require("../flags/1x1/fi.svg"));
var fj_svg_1 = __importDefault(require("../flags/1x1/fj.svg"));
var fk_svg_1 = __importDefault(require("../flags/1x1/fk.svg"));
var fm_svg_1 = __importDefault(require("../flags/1x1/fm.svg"));
var fo_svg_1 = __importDefault(require("../flags/1x1/fo.svg"));
var fr_svg_1 = __importDefault(require("../flags/1x1/fr.svg"));
var ga_svg_1 = __importDefault(require("../flags/1x1/ga.svg"));
var gb_eng_svg_1 = __importDefault(require("../flags/1x1/gb-eng.svg"));
var gb_nir_svg_1 = __importDefault(require("../flags/1x1/gb-nir.svg"));
var gb_sct_svg_1 = __importDefault(require("../flags/1x1/gb-sct.svg"));
var gb_wls_svg_1 = __importDefault(require("../flags/1x1/gb-wls.svg"));
var gb_svg_1 = __importDefault(require("../flags/1x1/gb.svg"));
var gd_svg_1 = __importDefault(require("../flags/1x1/gd.svg"));
var ge_svg_1 = __importDefault(require("../flags/1x1/ge.svg"));
var gf_svg_1 = __importDefault(require("../flags/1x1/gf.svg"));
var gg_svg_1 = __importDefault(require("../flags/1x1/gg.svg"));
var gh_svg_1 = __importDefault(require("../flags/1x1/gh.svg"));
var gi_svg_1 = __importDefault(require("../flags/1x1/gi.svg"));
var gl_svg_1 = __importDefault(require("../flags/1x1/gl.svg"));
var gm_svg_1 = __importDefault(require("../flags/1x1/gm.svg"));
var gn_svg_1 = __importDefault(require("../flags/1x1/gn.svg"));
var gp_svg_1 = __importDefault(require("../flags/1x1/gp.svg"));
var gq_svg_1 = __importDefault(require("../flags/1x1/gq.svg"));
var gr_svg_1 = __importDefault(require("../flags/1x1/gr.svg"));
var gs_svg_1 = __importDefault(require("../flags/1x1/gs.svg"));
var gt_svg_1 = __importDefault(require("../flags/1x1/gt.svg"));
var gu_svg_1 = __importDefault(require("../flags/1x1/gu.svg"));
var gw_svg_1 = __importDefault(require("../flags/1x1/gw.svg"));
var gy_svg_1 = __importDefault(require("../flags/1x1/gy.svg"));
var hk_svg_1 = __importDefault(require("../flags/1x1/hk.svg"));
var hm_svg_1 = __importDefault(require("../flags/1x1/hm.svg"));
var hn_svg_1 = __importDefault(require("../flags/1x1/hn.svg"));
var hr_svg_1 = __importDefault(require("../flags/1x1/hr.svg"));
var ht_svg_1 = __importDefault(require("../flags/1x1/ht.svg"));
var hu_svg_1 = __importDefault(require("../flags/1x1/hu.svg"));
var ic_svg_1 = __importDefault(require("../flags/1x1/ic.svg"));
var id_svg_1 = __importDefault(require("../flags/1x1/id.svg"));
var ie_svg_1 = __importDefault(require("../flags/1x1/ie.svg"));
var il_svg_1 = __importDefault(require("../flags/1x1/il.svg"));
var im_svg_1 = __importDefault(require("../flags/1x1/im.svg"));
var in_svg_1 = __importDefault(require("../flags/1x1/in.svg"));
var io_svg_1 = __importDefault(require("../flags/1x1/io.svg"));
var iq_svg_1 = __importDefault(require("../flags/1x1/iq.svg"));
var ir_svg_1 = __importDefault(require("../flags/1x1/ir.svg"));
var is_svg_1 = __importDefault(require("../flags/1x1/is.svg"));
var it_svg_1 = __importDefault(require("../flags/1x1/it.svg"));
var je_svg_1 = __importDefault(require("../flags/1x1/je.svg"));
var jm_svg_1 = __importDefault(require("../flags/1x1/jm.svg"));
var jo_svg_1 = __importDefault(require("../flags/1x1/jo.svg"));
var jp_svg_1 = __importDefault(require("../flags/1x1/jp.svg"));
var ke_svg_1 = __importDefault(require("../flags/1x1/ke.svg"));
var kg_svg_1 = __importDefault(require("../flags/1x1/kg.svg"));
var kh_svg_1 = __importDefault(require("../flags/1x1/kh.svg"));
var ki_svg_1 = __importDefault(require("../flags/1x1/ki.svg"));
var km_svg_1 = __importDefault(require("../flags/1x1/km.svg"));
var kn_svg_1 = __importDefault(require("../flags/1x1/kn.svg"));
var kp_svg_1 = __importDefault(require("../flags/1x1/kp.svg"));
var kr_svg_1 = __importDefault(require("../flags/1x1/kr.svg"));
var kw_svg_1 = __importDefault(require("../flags/1x1/kw.svg"));
var ky_svg_1 = __importDefault(require("../flags/1x1/ky.svg"));
var kz_svg_1 = __importDefault(require("../flags/1x1/kz.svg"));
var la_svg_1 = __importDefault(require("../flags/1x1/la.svg"));
var lb_svg_1 = __importDefault(require("../flags/1x1/lb.svg"));
var lc_svg_1 = __importDefault(require("../flags/1x1/lc.svg"));
var li_svg_1 = __importDefault(require("../flags/1x1/li.svg"));
var lk_svg_1 = __importDefault(require("../flags/1x1/lk.svg"));
var lr_svg_1 = __importDefault(require("../flags/1x1/lr.svg"));
var ls_svg_1 = __importDefault(require("../flags/1x1/ls.svg"));
var lt_svg_1 = __importDefault(require("../flags/1x1/lt.svg"));
var lu_svg_1 = __importDefault(require("../flags/1x1/lu.svg"));
var lv_svg_1 = __importDefault(require("../flags/1x1/lv.svg"));
var ly_svg_1 = __importDefault(require("../flags/1x1/ly.svg"));
var ma_svg_1 = __importDefault(require("../flags/1x1/ma.svg"));
var mc_svg_1 = __importDefault(require("../flags/1x1/mc.svg"));
var md_svg_1 = __importDefault(require("../flags/1x1/md.svg"));
var me_svg_1 = __importDefault(require("../flags/1x1/me.svg"));
var mf_svg_1 = __importDefault(require("../flags/1x1/mf.svg"));
var mg_svg_1 = __importDefault(require("../flags/1x1/mg.svg"));
var mh_svg_1 = __importDefault(require("../flags/1x1/mh.svg"));
var mk_svg_1 = __importDefault(require("../flags/1x1/mk.svg"));
var ml_svg_1 = __importDefault(require("../flags/1x1/ml.svg"));
var mm_svg_1 = __importDefault(require("../flags/1x1/mm.svg"));
var mn_svg_1 = __importDefault(require("../flags/1x1/mn.svg"));
var mo_svg_1 = __importDefault(require("../flags/1x1/mo.svg"));
var mp_svg_1 = __importDefault(require("../flags/1x1/mp.svg"));
var mq_svg_1 = __importDefault(require("../flags/1x1/mq.svg"));
var mr_svg_1 = __importDefault(require("../flags/1x1/mr.svg"));
var ms_svg_1 = __importDefault(require("../flags/1x1/ms.svg"));
var mt_svg_1 = __importDefault(require("../flags/1x1/mt.svg"));
var mu_svg_1 = __importDefault(require("../flags/1x1/mu.svg"));
var mv_svg_1 = __importDefault(require("../flags/1x1/mv.svg"));
var mw_svg_1 = __importDefault(require("../flags/1x1/mw.svg"));
var mx_svg_1 = __importDefault(require("../flags/1x1/mx.svg"));
var my_svg_1 = __importDefault(require("../flags/1x1/my.svg"));
var mz_svg_1 = __importDefault(require("../flags/1x1/mz.svg"));
var na_svg_1 = __importDefault(require("../flags/1x1/na.svg"));
var nc_svg_1 = __importDefault(require("../flags/1x1/nc.svg"));
var ne_svg_1 = __importDefault(require("../flags/1x1/ne.svg"));
var nf_svg_1 = __importDefault(require("../flags/1x1/nf.svg"));
var ng_svg_1 = __importDefault(require("../flags/1x1/ng.svg"));
var ni_svg_1 = __importDefault(require("../flags/1x1/ni.svg"));
var nl_svg_1 = __importDefault(require("../flags/1x1/nl.svg"));
var no_svg_1 = __importDefault(require("../flags/1x1/no.svg"));
var np_svg_1 = __importDefault(require("../flags/1x1/np.svg"));
var nr_svg_1 = __importDefault(require("../flags/1x1/nr.svg"));
var nu_svg_1 = __importDefault(require("../flags/1x1/nu.svg"));
var nz_svg_1 = __importDefault(require("../flags/1x1/nz.svg"));
var om_svg_1 = __importDefault(require("../flags/1x1/om.svg"));
var pa_svg_1 = __importDefault(require("../flags/1x1/pa.svg"));
var pc_svg_1 = __importDefault(require("../flags/1x1/pc.svg"));
var pe_svg_1 = __importDefault(require("../flags/1x1/pe.svg"));
var pf_svg_1 = __importDefault(require("../flags/1x1/pf.svg"));
var pg_svg_1 = __importDefault(require("../flags/1x1/pg.svg"));
var ph_svg_1 = __importDefault(require("../flags/1x1/ph.svg"));
var pk_svg_1 = __importDefault(require("../flags/1x1/pk.svg"));
var pl_svg_1 = __importDefault(require("../flags/1x1/pl.svg"));
var pm_svg_1 = __importDefault(require("../flags/1x1/pm.svg"));
var pn_svg_1 = __importDefault(require("../flags/1x1/pn.svg"));
var pr_svg_1 = __importDefault(require("../flags/1x1/pr.svg"));
var ps_svg_1 = __importDefault(require("../flags/1x1/ps.svg"));
var pt_svg_1 = __importDefault(require("../flags/1x1/pt.svg"));
var pw_svg_1 = __importDefault(require("../flags/1x1/pw.svg"));
var py_svg_1 = __importDefault(require("../flags/1x1/py.svg"));
var qa_svg_1 = __importDefault(require("../flags/1x1/qa.svg"));
var re_svg_1 = __importDefault(require("../flags/1x1/re.svg"));
var ro_svg_1 = __importDefault(require("../flags/1x1/ro.svg"));
var rs_svg_1 = __importDefault(require("../flags/1x1/rs.svg"));
var ru_svg_1 = __importDefault(require("../flags/1x1/ru.svg"));
var rw_svg_1 = __importDefault(require("../flags/1x1/rw.svg"));
var sa_svg_1 = __importDefault(require("../flags/1x1/sa.svg"));
var sb_svg_1 = __importDefault(require("../flags/1x1/sb.svg"));
var sc_svg_1 = __importDefault(require("../flags/1x1/sc.svg"));
var sd_svg_1 = __importDefault(require("../flags/1x1/sd.svg"));
var se_svg_1 = __importDefault(require("../flags/1x1/se.svg"));
var sg_svg_1 = __importDefault(require("../flags/1x1/sg.svg"));
var sh_ac_svg_1 = __importDefault(require("../flags/1x1/sh-ac.svg"));
var sh_hl_svg_1 = __importDefault(require("../flags/1x1/sh-hl.svg"));
var sh_ta_svg_1 = __importDefault(require("../flags/1x1/sh-ta.svg"));
var sh_svg_1 = __importDefault(require("../flags/1x1/sh.svg"));
var si_svg_1 = __importDefault(require("../flags/1x1/si.svg"));
var sj_svg_1 = __importDefault(require("../flags/1x1/sj.svg"));
var sk_svg_1 = __importDefault(require("../flags/1x1/sk.svg"));
var sl_svg_1 = __importDefault(require("../flags/1x1/sl.svg"));
var sm_svg_1 = __importDefault(require("../flags/1x1/sm.svg"));
var sn_svg_1 = __importDefault(require("../flags/1x1/sn.svg"));
var so_svg_1 = __importDefault(require("../flags/1x1/so.svg"));
var sr_svg_1 = __importDefault(require("../flags/1x1/sr.svg"));
var ss_svg_1 = __importDefault(require("../flags/1x1/ss.svg"));
var st_svg_1 = __importDefault(require("../flags/1x1/st.svg"));
var sv_svg_1 = __importDefault(require("../flags/1x1/sv.svg"));
var sx_svg_1 = __importDefault(require("../flags/1x1/sx.svg"));
var sy_svg_1 = __importDefault(require("../flags/1x1/sy.svg"));
var sz_svg_1 = __importDefault(require("../flags/1x1/sz.svg"));
var tc_svg_1 = __importDefault(require("../flags/1x1/tc.svg"));
var td_svg_1 = __importDefault(require("../flags/1x1/td.svg"));
var tf_svg_1 = __importDefault(require("../flags/1x1/tf.svg"));
var tg_svg_1 = __importDefault(require("../flags/1x1/tg.svg"));
var th_svg_1 = __importDefault(require("../flags/1x1/th.svg"));
var tj_svg_1 = __importDefault(require("../flags/1x1/tj.svg"));
var tk_svg_1 = __importDefault(require("../flags/1x1/tk.svg"));
var tl_svg_1 = __importDefault(require("../flags/1x1/tl.svg"));
var tm_svg_1 = __importDefault(require("../flags/1x1/tm.svg"));
var tn_svg_1 = __importDefault(require("../flags/1x1/tn.svg"));
var to_svg_1 = __importDefault(require("../flags/1x1/to.svg"));
var tr_svg_1 = __importDefault(require("../flags/1x1/tr.svg"));
var tt_svg_1 = __importDefault(require("../flags/1x1/tt.svg"));
var tv_svg_1 = __importDefault(require("../flags/1x1/tv.svg"));
var tw_svg_1 = __importDefault(require("../flags/1x1/tw.svg"));
var tz_svg_1 = __importDefault(require("../flags/1x1/tz.svg"));
var ua_svg_1 = __importDefault(require("../flags/1x1/ua.svg"));
var ug_svg_1 = __importDefault(require("../flags/1x1/ug.svg"));
var um_svg_1 = __importDefault(require("../flags/1x1/um.svg"));
var un_svg_1 = __importDefault(require("../flags/1x1/un.svg"));
var us_svg_1 = __importDefault(require("../flags/1x1/us.svg"));
var uy_svg_1 = __importDefault(require("../flags/1x1/uy.svg"));
var uz_svg_1 = __importDefault(require("../flags/1x1/uz.svg"));
var va_svg_1 = __importDefault(require("../flags/1x1/va.svg"));
var vc_svg_1 = __importDefault(require("../flags/1x1/vc.svg"));
var ve_svg_1 = __importDefault(require("../flags/1x1/ve.svg"));
var vg_svg_1 = __importDefault(require("../flags/1x1/vg.svg"));
var vi_svg_1 = __importDefault(require("../flags/1x1/vi.svg"));
var vn_svg_1 = __importDefault(require("../flags/1x1/vn.svg"));
var vu_svg_1 = __importDefault(require("../flags/1x1/vu.svg"));
var wf_svg_1 = __importDefault(require("../flags/1x1/wf.svg"));
var ws_svg_1 = __importDefault(require("../flags/1x1/ws.svg"));
var xk_svg_1 = __importDefault(require("../flags/1x1/xk.svg"));
var xx_svg_1 = __importDefault(require("../flags/1x1/xx.svg"));
var ye_svg_1 = __importDefault(require("../flags/1x1/ye.svg"));
var yt_svg_1 = __importDefault(require("../flags/1x1/yt.svg"));
var za_svg_1 = __importDefault(require("../flags/1x1/za.svg"));
var zm_svg_1 = __importDefault(require("../flags/1x1/zm.svg"));
var zw_svg_1 = __importDefault(require("../flags/1x1/zw.svg"));
var ad_svg_2 = __importDefault(require("../flags/4x3/ad.svg"));
var ae_svg_2 = __importDefault(require("../flags/4x3/ae.svg"));
var af_svg_2 = __importDefault(require("../flags/4x3/af.svg"));
var ag_svg_2 = __importDefault(require("../flags/4x3/ag.svg"));
var ai_svg_2 = __importDefault(require("../flags/4x3/ai.svg"));
var al_svg_2 = __importDefault(require("../flags/4x3/al.svg"));
var am_svg_2 = __importDefault(require("../flags/4x3/am.svg"));
var ao_svg_2 = __importDefault(require("../flags/4x3/ao.svg"));
var aq_svg_2 = __importDefault(require("../flags/4x3/aq.svg"));
var ar_svg_2 = __importDefault(require("../flags/4x3/ar.svg"));
var arab_svg_2 = __importDefault(require("../flags/4x3/arab.svg"));
var as_svg_2 = __importDefault(require("../flags/4x3/as.svg"));
var asean_svg_2 = __importDefault(require("../flags/4x3/asean.svg"));
var at_svg_2 = __importDefault(require("../flags/4x3/at.svg"));
var au_svg_2 = __importDefault(require("../flags/4x3/au.svg"));
var aw_svg_2 = __importDefault(require("../flags/4x3/aw.svg"));
var ax_svg_2 = __importDefault(require("../flags/4x3/ax.svg"));
var az_svg_2 = __importDefault(require("../flags/4x3/az.svg"));
var ba_svg_2 = __importDefault(require("../flags/4x3/ba.svg"));
var bb_svg_2 = __importDefault(require("../flags/4x3/bb.svg"));
var bd_svg_2 = __importDefault(require("../flags/4x3/bd.svg"));
var be_svg_2 = __importDefault(require("../flags/4x3/be.svg"));
var bf_svg_2 = __importDefault(require("../flags/4x3/bf.svg"));
var bg_svg_2 = __importDefault(require("../flags/4x3/bg.svg"));
var bh_svg_2 = __importDefault(require("../flags/4x3/bh.svg"));
var bi_svg_2 = __importDefault(require("../flags/4x3/bi.svg"));
var bj_svg_2 = __importDefault(require("../flags/4x3/bj.svg"));
var bl_svg_2 = __importDefault(require("../flags/4x3/bl.svg"));
var bm_svg_2 = __importDefault(require("../flags/4x3/bm.svg"));
var bn_svg_2 = __importDefault(require("../flags/4x3/bn.svg"));
var bo_svg_2 = __importDefault(require("../flags/4x3/bo.svg"));
var bq_svg_2 = __importDefault(require("../flags/4x3/bq.svg"));
var br_svg_2 = __importDefault(require("../flags/4x3/br.svg"));
var bs_svg_2 = __importDefault(require("../flags/4x3/bs.svg"));
var bt_svg_2 = __importDefault(require("../flags/4x3/bt.svg"));
var bv_svg_2 = __importDefault(require("../flags/4x3/bv.svg"));
var bw_svg_2 = __importDefault(require("../flags/4x3/bw.svg"));
var by_svg_2 = __importDefault(require("../flags/4x3/by.svg"));
var bz_svg_2 = __importDefault(require("../flags/4x3/bz.svg"));
var ca_svg_2 = __importDefault(require("../flags/4x3/ca.svg"));
var cc_svg_2 = __importDefault(require("../flags/4x3/cc.svg"));
var cd_svg_2 = __importDefault(require("../flags/4x3/cd.svg"));
var cefta_svg_2 = __importDefault(require("../flags/4x3/cefta.svg"));
var cf_svg_2 = __importDefault(require("../flags/4x3/cf.svg"));
var cg_svg_2 = __importDefault(require("../flags/4x3/cg.svg"));
var ch_svg_2 = __importDefault(require("../flags/4x3/ch.svg"));
var ci_svg_2 = __importDefault(require("../flags/4x3/ci.svg"));
var ck_svg_2 = __importDefault(require("../flags/4x3/ck.svg"));
var cl_svg_2 = __importDefault(require("../flags/4x3/cl.svg"));
var cm_svg_2 = __importDefault(require("../flags/4x3/cm.svg"));
var cn_svg_2 = __importDefault(require("../flags/4x3/cn.svg"));
var co_svg_2 = __importDefault(require("../flags/4x3/co.svg"));
var cp_svg_2 = __importDefault(require("../flags/4x3/cp.svg"));
var cr_svg_2 = __importDefault(require("../flags/4x3/cr.svg"));
var cu_svg_2 = __importDefault(require("../flags/4x3/cu.svg"));
var cv_svg_2 = __importDefault(require("../flags/4x3/cv.svg"));
var cw_svg_2 = __importDefault(require("../flags/4x3/cw.svg"));
var cx_svg_2 = __importDefault(require("../flags/4x3/cx.svg"));
var cy_svg_2 = __importDefault(require("../flags/4x3/cy.svg"));
var cz_svg_2 = __importDefault(require("../flags/4x3/cz.svg"));
var de_svg_2 = __importDefault(require("../flags/4x3/de.svg"));
var dg_svg_2 = __importDefault(require("../flags/4x3/dg.svg"));
var dj_svg_2 = __importDefault(require("../flags/4x3/dj.svg"));
var dk_svg_2 = __importDefault(require("../flags/4x3/dk.svg"));
var dm_svg_2 = __importDefault(require("../flags/4x3/dm.svg"));
var do_svg_2 = __importDefault(require("../flags/4x3/do.svg"));
var dz_svg_2 = __importDefault(require("../flags/4x3/dz.svg"));
var eac_svg_2 = __importDefault(require("../flags/4x3/eac.svg"));
var ec_svg_2 = __importDefault(require("../flags/4x3/ec.svg"));
var ee_svg_2 = __importDefault(require("../flags/4x3/ee.svg"));
var eg_svg_2 = __importDefault(require("../flags/4x3/eg.svg"));
var eh_svg_2 = __importDefault(require("../flags/4x3/eh.svg"));
var er_svg_2 = __importDefault(require("../flags/4x3/er.svg"));
var es_ct_svg_2 = __importDefault(require("../flags/4x3/es-ct.svg"));
var es_ga_svg_2 = __importDefault(require("../flags/4x3/es-ga.svg"));
var es_pv_svg_2 = __importDefault(require("../flags/4x3/es-pv.svg"));
var es_svg_2 = __importDefault(require("../flags/4x3/es.svg"));
var et_svg_2 = __importDefault(require("../flags/4x3/et.svg"));
var eu_svg_2 = __importDefault(require("../flags/4x3/eu.svg"));
var fi_svg_2 = __importDefault(require("../flags/4x3/fi.svg"));
var fj_svg_2 = __importDefault(require("../flags/4x3/fj.svg"));
var fk_svg_2 = __importDefault(require("../flags/4x3/fk.svg"));
var fm_svg_2 = __importDefault(require("../flags/4x3/fm.svg"));
var fo_svg_2 = __importDefault(require("../flags/4x3/fo.svg"));
var fr_svg_2 = __importDefault(require("../flags/4x3/fr.svg"));
var ga_svg_2 = __importDefault(require("../flags/4x3/ga.svg"));
var gb_eng_svg_2 = __importDefault(require("../flags/4x3/gb-eng.svg"));
var gb_nir_svg_2 = __importDefault(require("../flags/4x3/gb-nir.svg"));
var gb_sct_svg_2 = __importDefault(require("../flags/4x3/gb-sct.svg"));
var gb_wls_svg_2 = __importDefault(require("../flags/4x3/gb-wls.svg"));
var gb_svg_2 = __importDefault(require("../flags/4x3/gb.svg"));
var gd_svg_2 = __importDefault(require("../flags/4x3/gd.svg"));
var ge_svg_2 = __importDefault(require("../flags/4x3/ge.svg"));
var gf_svg_2 = __importDefault(require("../flags/4x3/gf.svg"));
var gg_svg_2 = __importDefault(require("../flags/4x3/gg.svg"));
var gh_svg_2 = __importDefault(require("../flags/4x3/gh.svg"));
var gi_svg_2 = __importDefault(require("../flags/4x3/gi.svg"));
var gl_svg_2 = __importDefault(require("../flags/4x3/gl.svg"));
var gm_svg_2 = __importDefault(require("../flags/4x3/gm.svg"));
var gn_svg_2 = __importDefault(require("../flags/4x3/gn.svg"));
var gp_svg_2 = __importDefault(require("../flags/4x3/gp.svg"));
var gq_svg_2 = __importDefault(require("../flags/4x3/gq.svg"));
var gr_svg_2 = __importDefault(require("../flags/4x3/gr.svg"));
var gs_svg_2 = __importDefault(require("../flags/4x3/gs.svg"));
var gt_svg_2 = __importDefault(require("../flags/4x3/gt.svg"));
var gu_svg_2 = __importDefault(require("../flags/4x3/gu.svg"));
var gw_svg_2 = __importDefault(require("../flags/4x3/gw.svg"));
var gy_svg_2 = __importDefault(require("../flags/4x3/gy.svg"));
var hk_svg_2 = __importDefault(require("../flags/4x3/hk.svg"));
var hm_svg_2 = __importDefault(require("../flags/4x3/hm.svg"));
var hn_svg_2 = __importDefault(require("../flags/4x3/hn.svg"));
var hr_svg_2 = __importDefault(require("../flags/4x3/hr.svg"));
var ht_svg_2 = __importDefault(require("../flags/4x3/ht.svg"));
var hu_svg_2 = __importDefault(require("../flags/4x3/hu.svg"));
var ic_svg_2 = __importDefault(require("../flags/4x3/ic.svg"));
var id_svg_2 = __importDefault(require("../flags/4x3/id.svg"));
var ie_svg_2 = __importDefault(require("../flags/4x3/ie.svg"));
var il_svg_2 = __importDefault(require("../flags/4x3/il.svg"));
var im_svg_2 = __importDefault(require("../flags/4x3/im.svg"));
var in_svg_2 = __importDefault(require("../flags/4x3/in.svg"));
var io_svg_2 = __importDefault(require("../flags/4x3/io.svg"));
var iq_svg_2 = __importDefault(require("../flags/4x3/iq.svg"));
var ir_svg_2 = __importDefault(require("../flags/4x3/ir.svg"));
var is_svg_2 = __importDefault(require("../flags/4x3/is.svg"));
var it_svg_2 = __importDefault(require("../flags/4x3/it.svg"));
var je_svg_2 = __importDefault(require("../flags/4x3/je.svg"));
var jm_svg_2 = __importDefault(require("../flags/4x3/jm.svg"));
var jo_svg_2 = __importDefault(require("../flags/4x3/jo.svg"));
var jp_svg_2 = __importDefault(require("../flags/4x3/jp.svg"));
var ke_svg_2 = __importDefault(require("../flags/4x3/ke.svg"));
var kg_svg_2 = __importDefault(require("../flags/4x3/kg.svg"));
var kh_svg_2 = __importDefault(require("../flags/4x3/kh.svg"));
var ki_svg_2 = __importDefault(require("../flags/4x3/ki.svg"));
var km_svg_2 = __importDefault(require("../flags/4x3/km.svg"));
var kn_svg_2 = __importDefault(require("../flags/4x3/kn.svg"));
var kp_svg_2 = __importDefault(require("../flags/4x3/kp.svg"));
var kr_svg_2 = __importDefault(require("../flags/4x3/kr.svg"));
var kw_svg_2 = __importDefault(require("../flags/4x3/kw.svg"));
var ky_svg_2 = __importDefault(require("../flags/4x3/ky.svg"));
var kz_svg_2 = __importDefault(require("../flags/4x3/kz.svg"));
var la_svg_2 = __importDefault(require("../flags/4x3/la.svg"));
var lb_svg_2 = __importDefault(require("../flags/4x3/lb.svg"));
var lc_svg_2 = __importDefault(require("../flags/4x3/lc.svg"));
var li_svg_2 = __importDefault(require("../flags/4x3/li.svg"));
var lk_svg_2 = __importDefault(require("../flags/4x3/lk.svg"));
var lr_svg_2 = __importDefault(require("../flags/4x3/lr.svg"));
var ls_svg_2 = __importDefault(require("../flags/4x3/ls.svg"));
var lt_svg_2 = __importDefault(require("../flags/4x3/lt.svg"));
var lu_svg_2 = __importDefault(require("../flags/4x3/lu.svg"));
var lv_svg_2 = __importDefault(require("../flags/4x3/lv.svg"));
var ly_svg_2 = __importDefault(require("../flags/4x3/ly.svg"));
var ma_svg_2 = __importDefault(require("../flags/4x3/ma.svg"));
var mc_svg_2 = __importDefault(require("../flags/4x3/mc.svg"));
var md_svg_2 = __importDefault(require("../flags/4x3/md.svg"));
var me_svg_2 = __importDefault(require("../flags/4x3/me.svg"));
var mf_svg_2 = __importDefault(require("../flags/4x3/mf.svg"));
var mg_svg_2 = __importDefault(require("../flags/4x3/mg.svg"));
var mh_svg_2 = __importDefault(require("../flags/4x3/mh.svg"));
var mk_svg_2 = __importDefault(require("../flags/4x3/mk.svg"));
var ml_svg_2 = __importDefault(require("../flags/4x3/ml.svg"));
var mm_svg_2 = __importDefault(require("../flags/4x3/mm.svg"));
var mn_svg_2 = __importDefault(require("../flags/4x3/mn.svg"));
var mo_svg_2 = __importDefault(require("../flags/4x3/mo.svg"));
var mp_svg_2 = __importDefault(require("../flags/4x3/mp.svg"));
var mq_svg_2 = __importDefault(require("../flags/4x3/mq.svg"));
var mr_svg_2 = __importDefault(require("../flags/4x3/mr.svg"));
var ms_svg_2 = __importDefault(require("../flags/4x3/ms.svg"));
var mt_svg_2 = __importDefault(require("../flags/4x3/mt.svg"));
var mu_svg_2 = __importDefault(require("../flags/4x3/mu.svg"));
var mv_svg_2 = __importDefault(require("../flags/4x3/mv.svg"));
var mw_svg_2 = __importDefault(require("../flags/4x3/mw.svg"));
var mx_svg_2 = __importDefault(require("../flags/4x3/mx.svg"));
var my_svg_2 = __importDefault(require("../flags/4x3/my.svg"));
var mz_svg_2 = __importDefault(require("../flags/4x3/mz.svg"));
var na_svg_2 = __importDefault(require("../flags/4x3/na.svg"));
var nc_svg_2 = __importDefault(require("../flags/4x3/nc.svg"));
var ne_svg_2 = __importDefault(require("../flags/4x3/ne.svg"));
var nf_svg_2 = __importDefault(require("../flags/4x3/nf.svg"));
var ng_svg_2 = __importDefault(require("../flags/4x3/ng.svg"));
var ni_svg_2 = __importDefault(require("../flags/4x3/ni.svg"));
var nl_svg_2 = __importDefault(require("../flags/4x3/nl.svg"));
var no_svg_2 = __importDefault(require("../flags/4x3/no.svg"));
var np_svg_2 = __importDefault(require("../flags/4x3/np.svg"));
var nr_svg_2 = __importDefault(require("../flags/4x3/nr.svg"));
var nu_svg_2 = __importDefault(require("../flags/4x3/nu.svg"));
var nz_svg_2 = __importDefault(require("../flags/4x3/nz.svg"));
var om_svg_2 = __importDefault(require("../flags/4x3/om.svg"));
var pa_svg_2 = __importDefault(require("../flags/4x3/pa.svg"));
var pc_svg_2 = __importDefault(require("../flags/4x3/pc.svg"));
var pe_svg_2 = __importDefault(require("../flags/4x3/pe.svg"));
var pf_svg_2 = __importDefault(require("../flags/4x3/pf.svg"));
var pg_svg_2 = __importDefault(require("../flags/4x3/pg.svg"));
var ph_svg_2 = __importDefault(require("../flags/4x3/ph.svg"));
var pk_svg_2 = __importDefault(require("../flags/4x3/pk.svg"));
var pl_svg_2 = __importDefault(require("../flags/4x3/pl.svg"));
var pm_svg_2 = __importDefault(require("../flags/4x3/pm.svg"));
var pn_svg_2 = __importDefault(require("../flags/4x3/pn.svg"));
var pr_svg_2 = __importDefault(require("../flags/4x3/pr.svg"));
var ps_svg_2 = __importDefault(require("../flags/4x3/ps.svg"));
var pt_svg_2 = __importDefault(require("../flags/4x3/pt.svg"));
var pw_svg_2 = __importDefault(require("../flags/4x3/pw.svg"));
var py_svg_2 = __importDefault(require("../flags/4x3/py.svg"));
var qa_svg_2 = __importDefault(require("../flags/4x3/qa.svg"));
var re_svg_2 = __importDefault(require("../flags/4x3/re.svg"));
var ro_svg_2 = __importDefault(require("../flags/4x3/ro.svg"));
var rs_svg_2 = __importDefault(require("../flags/4x3/rs.svg"));
var ru_svg_2 = __importDefault(require("../flags/4x3/ru.svg"));
var rw_svg_2 = __importDefault(require("../flags/4x3/rw.svg"));
var sa_svg_2 = __importDefault(require("../flags/4x3/sa.svg"));
var sb_svg_2 = __importDefault(require("../flags/4x3/sb.svg"));
var sc_svg_2 = __importDefault(require("../flags/4x3/sc.svg"));
var sd_svg_2 = __importDefault(require("../flags/4x3/sd.svg"));
var se_svg_2 = __importDefault(require("../flags/4x3/se.svg"));
var sg_svg_2 = __importDefault(require("../flags/4x3/sg.svg"));
var sh_ac_svg_2 = __importDefault(require("../flags/4x3/sh-ac.svg"));
var sh_hl_svg_2 = __importDefault(require("../flags/4x3/sh-hl.svg"));
var sh_ta_svg_2 = __importDefault(require("../flags/4x3/sh-ta.svg"));
var sh_svg_2 = __importDefault(require("../flags/4x3/sh.svg"));
var si_svg_2 = __importDefault(require("../flags/4x3/si.svg"));
var sj_svg_2 = __importDefault(require("../flags/4x3/sj.svg"));
var sk_svg_2 = __importDefault(require("../flags/4x3/sk.svg"));
var sl_svg_2 = __importDefault(require("../flags/4x3/sl.svg"));
var sm_svg_2 = __importDefault(require("../flags/4x3/sm.svg"));
var sn_svg_2 = __importDefault(require("../flags/4x3/sn.svg"));
var so_svg_2 = __importDefault(require("../flags/4x3/so.svg"));
var sr_svg_2 = __importDefault(require("../flags/4x3/sr.svg"));
var ss_svg_2 = __importDefault(require("../flags/4x3/ss.svg"));
var st_svg_2 = __importDefault(require("../flags/4x3/st.svg"));
var sv_svg_2 = __importDefault(require("../flags/4x3/sv.svg"));
var sx_svg_2 = __importDefault(require("../flags/4x3/sx.svg"));
var sy_svg_2 = __importDefault(require("../flags/4x3/sy.svg"));
var sz_svg_2 = __importDefault(require("../flags/4x3/sz.svg"));
var tc_svg_2 = __importDefault(require("../flags/4x3/tc.svg"));
var td_svg_2 = __importDefault(require("../flags/4x3/td.svg"));
var tf_svg_2 = __importDefault(require("../flags/4x3/tf.svg"));
var tg_svg_2 = __importDefault(require("../flags/4x3/tg.svg"));
var th_svg_2 = __importDefault(require("../flags/4x3/th.svg"));
var tj_svg_2 = __importDefault(require("../flags/4x3/tj.svg"));
var tk_svg_2 = __importDefault(require("../flags/4x3/tk.svg"));
var tl_svg_2 = __importDefault(require("../flags/4x3/tl.svg"));
var tm_svg_2 = __importDefault(require("../flags/4x3/tm.svg"));
var tn_svg_2 = __importDefault(require("../flags/4x3/tn.svg"));
var to_svg_2 = __importDefault(require("../flags/4x3/to.svg"));
var tr_svg_2 = __importDefault(require("../flags/4x3/tr.svg"));
var tt_svg_2 = __importDefault(require("../flags/4x3/tt.svg"));
var tv_svg_2 = __importDefault(require("../flags/4x3/tv.svg"));
var tw_svg_2 = __importDefault(require("../flags/4x3/tw.svg"));
var tz_svg_2 = __importDefault(require("../flags/4x3/tz.svg"));
var ua_svg_2 = __importDefault(require("../flags/4x3/ua.svg"));
var ug_svg_2 = __importDefault(require("../flags/4x3/ug.svg"));
var um_svg_2 = __importDefault(require("../flags/4x3/um.svg"));
var un_svg_2 = __importDefault(require("../flags/4x3/un.svg"));
var us_svg_2 = __importDefault(require("../flags/4x3/us.svg"));
var uy_svg_2 = __importDefault(require("../flags/4x3/uy.svg"));
var uz_svg_2 = __importDefault(require("../flags/4x3/uz.svg"));
var va_svg_2 = __importDefault(require("../flags/4x3/va.svg"));
var vc_svg_2 = __importDefault(require("../flags/4x3/vc.svg"));
var ve_svg_2 = __importDefault(require("../flags/4x3/ve.svg"));
var vg_svg_2 = __importDefault(require("../flags/4x3/vg.svg"));
var vi_svg_2 = __importDefault(require("../flags/4x3/vi.svg"));
var vn_svg_2 = __importDefault(require("../flags/4x3/vn.svg"));
var vu_svg_2 = __importDefault(require("../flags/4x3/vu.svg"));
var wf_svg_2 = __importDefault(require("../flags/4x3/wf.svg"));
var ws_svg_2 = __importDefault(require("../flags/4x3/ws.svg"));
var xk_svg_2 = __importDefault(require("../flags/4x3/xk.svg"));
var xx_svg_2 = __importDefault(require("../flags/4x3/xx.svg"));
var ye_svg_2 = __importDefault(require("../flags/4x3/ye.svg"));
var yt_svg_2 = __importDefault(require("../flags/4x3/yt.svg"));
var za_svg_2 = __importDefault(require("../flags/4x3/za.svg"));
var zm_svg_2 = __importDefault(require("../flags/4x3/zm.svg"));
var zw_svg_2 = __importDefault(require("../flags/4x3/zw.svg"));
exports.dicionarioBandeiras = {
    AD_1x1: ad_svg_1.default,
    AD_4x3: ad_svg_2.default,
    AE_1x1: ae_svg_1.default,
    AE_4x3: ae_svg_2.default,
    AF_1x1: af_svg_1.default,
    AF_4x3: af_svg_2.default,
    AG_1x1: ag_svg_1.default,
    AG_4x3: ag_svg_2.default,
    AI_1x1: ai_svg_1.default,
    AI_4x3: ai_svg_2.default,
    AL_1x1: al_svg_1.default,
    AL_4x3: al_svg_2.default,
    AM_1x1: am_svg_1.default,
    AM_4x3: am_svg_2.default,
    AO_1x1: ao_svg_1.default,
    AO_4x3: ao_svg_2.default,
    AQ_1x1: aq_svg_1.default,
    AQ_4x3: aq_svg_2.default,
    AR_1x1: ar_svg_1.default,
    AR_4x3: ar_svg_2.default,
    ARAB_1x1: arab_svg_1.default,
    ARAB_4x3: arab_svg_2.default,
    AS_1x1: as_svg_1.default,
    AS_4x3: as_svg_2.default,
    ASEAN_1x1: asean_svg_1.default,
    ASEAN_4x3: asean_svg_2.default,
    AT_1x1: at_svg_1.default,
    AT_4x3: at_svg_2.default,
    AU_1x1: au_svg_1.default,
    AU_4x3: au_svg_2.default,
    AW_1x1: aw_svg_1.default,
    AW_4x3: aw_svg_2.default,
    AX_1x1: ax_svg_1.default,
    AX_4x3: ax_svg_2.default,
    AZ_1x1: az_svg_1.default,
    AZ_4x3: az_svg_2.default,
    BA_1x1: ba_svg_1.default,
    BA_4x3: ba_svg_2.default,
    BB_1x1: bb_svg_1.default,
    BB_4x3: bb_svg_2.default,
    BD_1x1: bd_svg_1.default,
    BD_4x3: bd_svg_2.default,
    BE_1x1: be_svg_1.default,
    BE_4x3: be_svg_2.default,
    BF_1x1: bf_svg_1.default,
    BF_4x3: bf_svg_2.default,
    BG_1x1: bg_svg_1.default,
    BG_4x3: bg_svg_2.default,
    BH_1x1: bh_svg_1.default,
    BH_4x3: bh_svg_2.default,
    BI_1x1: bi_svg_1.default,
    BI_4x3: bi_svg_2.default,
    BJ_1x1: bj_svg_1.default,
    BJ_4x3: bj_svg_2.default,
    BL_1x1: bl_svg_1.default,
    BL_4x3: bl_svg_2.default,
    BM_1x1: bm_svg_1.default,
    BM_4x3: bm_svg_2.default,
    BN_1x1: bn_svg_1.default,
    BN_4x3: bn_svg_2.default,
    BO_1x1: bo_svg_1.default,
    BO_4x3: bo_svg_2.default,
    BQ_1x1: bq_svg_1.default,
    BQ_4x3: bq_svg_2.default,
    BR_1x1: br_svg_1.default,
    BR_4x3: br_svg_2.default,
    BS_1x1: bs_svg_1.default,
    BS_4x3: bs_svg_2.default,
    BT_1x1: bt_svg_1.default,
    BT_4x3: bt_svg_2.default,
    BV_1x1: bv_svg_1.default,
    BV_4x3: bv_svg_2.default,
    BW_1x1: bw_svg_1.default,
    BW_4x3: bw_svg_2.default,
    BY_1x1: by_svg_1.default,
    BY_4x3: by_svg_2.default,
    BZ_1x1: bz_svg_1.default,
    BZ_4x3: bz_svg_2.default,
    CA_1x1: ca_svg_1.default,
    CA_4x3: ca_svg_2.default,
    CC_1x1: cc_svg_1.default,
    CC_4x3: cc_svg_2.default,
    CD_1x1: cd_svg_1.default,
    CD_4x3: cd_svg_2.default,
    CEFTA_1x1: cefta_svg_1.default,
    CEFTA_4x3: cefta_svg_2.default,
    CF_1x1: cf_svg_1.default,
    CF_4x3: cf_svg_2.default,
    CG_1x1: cg_svg_1.default,
    CG_4x3: cg_svg_2.default,
    CH_1x1: ch_svg_1.default,
    CH_4x3: ch_svg_2.default,
    CI_1x1: ci_svg_1.default,
    CI_4x3: ci_svg_2.default,
    CK_1x1: ck_svg_1.default,
    CK_4x3: ck_svg_2.default,
    CL_1x1: cl_svg_1.default,
    CL_4x3: cl_svg_2.default,
    CM_1x1: cm_svg_1.default,
    CM_4x3: cm_svg_2.default,
    CN_1x1: cn_svg_1.default,
    CN_4x3: cn_svg_2.default,
    CO_1x1: co_svg_1.default,
    CO_4x3: co_svg_2.default,
    CP_1x1: cp_svg_1.default,
    CP_4x3: cp_svg_2.default,
    CR_1x1: cr_svg_1.default,
    CR_4x3: cr_svg_2.default,
    CU_1x1: cu_svg_1.default,
    CU_4x3: cu_svg_2.default,
    CV_1x1: cv_svg_1.default,
    CV_4x3: cv_svg_2.default,
    CW_1x1: cw_svg_1.default,
    CW_4x3: cw_svg_2.default,
    CX_1x1: cx_svg_1.default,
    CX_4x3: cx_svg_2.default,
    CY_1x1: cy_svg_1.default,
    CY_4x3: cy_svg_2.default,
    CZ_1x1: cz_svg_1.default,
    CZ_4x3: cz_svg_2.default,
    DE_1x1: de_svg_1.default,
    DE_4x3: de_svg_2.default,
    DG_1x1: dg_svg_1.default,
    DG_4x3: dg_svg_2.default,
    DJ_1x1: dj_svg_1.default,
    DJ_4x3: dj_svg_2.default,
    DK_1x1: dk_svg_1.default,
    DK_4x3: dk_svg_2.default,
    DM_1x1: dm_svg_1.default,
    DM_4x3: dm_svg_2.default,
    DO_1x1: do_svg_1.default,
    DO_4x3: do_svg_2.default,
    DZ_1x1: dz_svg_1.default,
    DZ_4x3: dz_svg_2.default,
    EAC_1x1: eac_svg_1.default,
    EAC_4x3: eac_svg_2.default,
    EC_1x1: ec_svg_1.default,
    EC_4x3: ec_svg_2.default,
    EE_1x1: ee_svg_1.default,
    EE_4x3: ee_svg_2.default,
    EG_1x1: eg_svg_1.default,
    EG_4x3: eg_svg_2.default,
    EH_1x1: eh_svg_1.default,
    EH_4x3: eh_svg_2.default,
    ER_1x1: er_svg_1.default,
    ER_4x3: er_svg_2.default,
    ES_CT_1x1: es_ct_svg_1.default,
    ES_CT_4x3: es_ct_svg_2.default,
    ES_GA_1x1: es_ga_svg_1.default,
    ES_GA_4x3: es_ga_svg_2.default,
    ES_PV_1x1: es_pv_svg_1.default,
    ES_PV_4x3: es_pv_svg_2.default,
    ES_1x1: es_svg_1.default,
    ES_4x3: es_svg_2.default,
    ET_1x1: et_svg_1.default,
    ET_4x3: et_svg_2.default,
    EU_1x1: eu_svg_1.default,
    EU_4x3: eu_svg_2.default,
    FI_1x1: fi_svg_1.default,
    FI_4x3: fi_svg_2.default,
    FJ_1x1: fj_svg_1.default,
    FJ_4x3: fj_svg_2.default,
    FK_1x1: fk_svg_1.default,
    FK_4x3: fk_svg_2.default,
    FM_1x1: fm_svg_1.default,
    FM_4x3: fm_svg_2.default,
    FO_1x1: fo_svg_1.default,
    FO_4x3: fo_svg_2.default,
    FR_1x1: fr_svg_1.default,
    FR_4x3: fr_svg_2.default,
    GA_1x1: ga_svg_1.default,
    GA_4x3: ga_svg_2.default,
    GB_ENG_1x1: gb_eng_svg_1.default,
    GB_ENG_4x3: gb_eng_svg_2.default,
    GB_NIR_1x1: gb_nir_svg_1.default,
    GB_NIR_4x3: gb_nir_svg_2.default,
    GB_SCT_1x1: gb_sct_svg_1.default,
    GB_SCT_4x3: gb_sct_svg_2.default,
    GB_WLS_1x1: gb_wls_svg_1.default,
    GB_WLS_4x3: gb_wls_svg_2.default,
    GB_1x1: gb_svg_1.default,
    GB_4x3: gb_svg_2.default,
    GD_1x1: gd_svg_1.default,
    GD_4x3: gd_svg_2.default,
    GE_1x1: ge_svg_1.default,
    GE_4x3: ge_svg_2.default,
    GF_1x1: gf_svg_1.default,
    GF_4x3: gf_svg_2.default,
    GG_1x1: gg_svg_1.default,
    GG_4x3: gg_svg_2.default,
    GH_1x1: gh_svg_1.default,
    GH_4x3: gh_svg_2.default,
    GI_1x1: gi_svg_1.default,
    GI_4x3: gi_svg_2.default,
    GL_1x1: gl_svg_1.default,
    GL_4x3: gl_svg_2.default,
    GM_1x1: gm_svg_1.default,
    GM_4x3: gm_svg_2.default,
    GN_1x1: gn_svg_1.default,
    GN_4x3: gn_svg_2.default,
    GP_1x1: gp_svg_1.default,
    GP_4x3: gp_svg_2.default,
    GQ_1x1: gq_svg_1.default,
    GQ_4x3: gq_svg_2.default,
    GR_1x1: gr_svg_1.default,
    GR_4x3: gr_svg_2.default,
    GS_1x1: gs_svg_1.default,
    GS_4x3: gs_svg_2.default,
    GT_1x1: gt_svg_1.default,
    GT_4x3: gt_svg_2.default,
    GU_1x1: gu_svg_1.default,
    GU_4x3: gu_svg_2.default,
    GW_1x1: gw_svg_1.default,
    GW_4x3: gw_svg_2.default,
    GY_1x1: gy_svg_1.default,
    GY_4x3: gy_svg_2.default,
    HK_1x1: hk_svg_1.default,
    HK_4x3: hk_svg_2.default,
    HM_1x1: hm_svg_1.default,
    HM_4x3: hm_svg_2.default,
    HN_1x1: hn_svg_1.default,
    HN_4x3: hn_svg_2.default,
    HR_1x1: hr_svg_1.default,
    HR_4x3: hr_svg_2.default,
    HT_1x1: ht_svg_1.default,
    HT_4x3: ht_svg_2.default,
    HU_1x1: hu_svg_1.default,
    HU_4x3: hu_svg_2.default,
    IC_1x1: ic_svg_1.default,
    IC_4x3: ic_svg_2.default,
    ID_1x1: id_svg_1.default,
    ID_4x3: id_svg_2.default,
    IE_1x1: ie_svg_1.default,
    IE_4x3: ie_svg_2.default,
    IL_1x1: il_svg_1.default,
    IL_4x3: il_svg_2.default,
    IM_1x1: im_svg_1.default,
    IM_4x3: im_svg_2.default,
    IN_1x1: in_svg_1.default,
    IN_4x3: in_svg_2.default,
    IO_1x1: io_svg_1.default,
    IO_4x3: io_svg_2.default,
    IQ_1x1: iq_svg_1.default,
    IQ_4x3: iq_svg_2.default,
    IR_1x1: ir_svg_1.default,
    IR_4x3: ir_svg_2.default,
    IS_1x1: is_svg_1.default,
    IS_4x3: is_svg_2.default,
    IT_1x1: it_svg_1.default,
    IT_4x3: it_svg_2.default,
    JE_1x1: je_svg_1.default,
    JE_4x3: je_svg_2.default,
    JM_1x1: jm_svg_1.default,
    JM_4x3: jm_svg_2.default,
    JO_1x1: jo_svg_1.default,
    JO_4x3: jo_svg_2.default,
    JP_1x1: jp_svg_1.default,
    JP_4x3: jp_svg_2.default,
    KE_1x1: ke_svg_1.default,
    KE_4x3: ke_svg_2.default,
    KG_1x1: kg_svg_1.default,
    KG_4x3: kg_svg_2.default,
    KH_1x1: kh_svg_1.default,
    KH_4x3: kh_svg_2.default,
    KI_1x1: ki_svg_1.default,
    KI_4x3: ki_svg_2.default,
    KM_1x1: km_svg_1.default,
    KM_4x3: km_svg_2.default,
    KN_1x1: kn_svg_1.default,
    KN_4x3: kn_svg_2.default,
    KP_1x1: kp_svg_1.default,
    KP_4x3: kp_svg_2.default,
    KR_1x1: kr_svg_1.default,
    KR_4x3: kr_svg_2.default,
    KW_1x1: kw_svg_1.default,
    KW_4x3: kw_svg_2.default,
    KY_1x1: ky_svg_1.default,
    KY_4x3: ky_svg_2.default,
    KZ_1x1: kz_svg_1.default,
    KZ_4x3: kz_svg_2.default,
    LA_1x1: la_svg_1.default,
    LA_4x3: la_svg_2.default,
    LB_1x1: lb_svg_1.default,
    LB_4x3: lb_svg_2.default,
    LC_1x1: lc_svg_1.default,
    LC_4x3: lc_svg_2.default,
    LI_1x1: li_svg_1.default,
    LI_4x3: li_svg_2.default,
    LK_1x1: lk_svg_1.default,
    LK_4x3: lk_svg_2.default,
    LR_1x1: lr_svg_1.default,
    LR_4x3: lr_svg_2.default,
    LS_1x1: ls_svg_1.default,
    LS_4x3: ls_svg_2.default,
    LT_1x1: lt_svg_1.default,
    LT_4x3: lt_svg_2.default,
    LU_1x1: lu_svg_1.default,
    LU_4x3: lu_svg_2.default,
    LV_1x1: lv_svg_1.default,
    LV_4x3: lv_svg_2.default,
    LY_1x1: ly_svg_1.default,
    LY_4x3: ly_svg_2.default,
    MA_1x1: ma_svg_1.default,
    MA_4x3: ma_svg_2.default,
    MC_1x1: mc_svg_1.default,
    MC_4x3: mc_svg_2.default,
    MD_1x1: md_svg_1.default,
    MD_4x3: md_svg_2.default,
    ME_1x1: me_svg_1.default,
    ME_4x3: me_svg_2.default,
    MF_1x1: mf_svg_1.default,
    MF_4x3: mf_svg_2.default,
    MG_1x1: mg_svg_1.default,
    MG_4x3: mg_svg_2.default,
    MH_1x1: mh_svg_1.default,
    MH_4x3: mh_svg_2.default,
    MK_1x1: mk_svg_1.default,
    MK_4x3: mk_svg_2.default,
    ML_1x1: ml_svg_1.default,
    ML_4x3: ml_svg_2.default,
    MM_1x1: mm_svg_1.default,
    MM_4x3: mm_svg_2.default,
    MN_1x1: mn_svg_1.default,
    MN_4x3: mn_svg_2.default,
    MO_1x1: mo_svg_1.default,
    MO_4x3: mo_svg_2.default,
    MP_1x1: mp_svg_1.default,
    MP_4x3: mp_svg_2.default,
    MQ_1x1: mq_svg_1.default,
    MQ_4x3: mq_svg_2.default,
    MR_1x1: mr_svg_1.default,
    MR_4x3: mr_svg_2.default,
    MS_1x1: ms_svg_1.default,
    MS_4x3: ms_svg_2.default,
    MT_1x1: mt_svg_1.default,
    MT_4x3: mt_svg_2.default,
    MU_1x1: mu_svg_1.default,
    MU_4x3: mu_svg_2.default,
    MV_1x1: mv_svg_1.default,
    MV_4x3: mv_svg_2.default,
    MW_1x1: mw_svg_1.default,
    MW_4x3: mw_svg_2.default,
    MX_1x1: mx_svg_1.default,
    MX_4x3: mx_svg_2.default,
    MY_1x1: my_svg_1.default,
    MY_4x3: my_svg_2.default,
    MZ_1x1: mz_svg_1.default,
    MZ_4x3: mz_svg_2.default,
    NA_1x1: na_svg_1.default,
    NA_4x3: na_svg_2.default,
    NC_1x1: nc_svg_1.default,
    NC_4x3: nc_svg_2.default,
    NE_1x1: ne_svg_1.default,
    NE_4x3: ne_svg_2.default,
    NF_1x1: nf_svg_1.default,
    NF_4x3: nf_svg_2.default,
    NG_1x1: ng_svg_1.default,
    NG_4x3: ng_svg_2.default,
    NI_1x1: ni_svg_1.default,
    NI_4x3: ni_svg_2.default,
    NL_1x1: nl_svg_1.default,
    NL_4x3: nl_svg_2.default,
    NO_1x1: no_svg_1.default,
    NO_4x3: no_svg_2.default,
    NP_1x1: np_svg_1.default,
    NP_4x3: np_svg_2.default,
    NR_1x1: nr_svg_1.default,
    NR_4x3: nr_svg_2.default,
    NU_1x1: nu_svg_1.default,
    NU_4x3: nu_svg_2.default,
    NZ_1x1: nz_svg_1.default,
    NZ_4x3: nz_svg_2.default,
    OM_1x1: om_svg_1.default,
    OM_4x3: om_svg_2.default,
    PA_1x1: pa_svg_1.default,
    PA_4x3: pa_svg_2.default,
    PC_1x1: pc_svg_1.default,
    PC_4x3: pc_svg_2.default,
    PE_1x1: pe_svg_1.default,
    PE_4x3: pe_svg_2.default,
    PF_1x1: pf_svg_1.default,
    PF_4x3: pf_svg_2.default,
    PG_1x1: pg_svg_1.default,
    PG_4x3: pg_svg_2.default,
    PH_1x1: ph_svg_1.default,
    PH_4x3: ph_svg_2.default,
    PK_1x1: pk_svg_1.default,
    PK_4x3: pk_svg_2.default,
    PL_1x1: pl_svg_1.default,
    PL_4x3: pl_svg_2.default,
    PM_1x1: pm_svg_1.default,
    PM_4x3: pm_svg_2.default,
    PN_1x1: pn_svg_1.default,
    PN_4x3: pn_svg_2.default,
    PR_1x1: pr_svg_1.default,
    PR_4x3: pr_svg_2.default,
    PS_1x1: ps_svg_1.default,
    PS_4x3: ps_svg_2.default,
    PT_1x1: pt_svg_1.default,
    PT_4x3: pt_svg_2.default,
    PW_1x1: pw_svg_1.default,
    PW_4x3: pw_svg_2.default,
    PY_1x1: py_svg_1.default,
    PY_4x3: py_svg_2.default,
    QA_1x1: qa_svg_1.default,
    QA_4x3: qa_svg_2.default,
    RE_1x1: re_svg_1.default,
    RE_4x3: re_svg_2.default,
    RO_1x1: ro_svg_1.default,
    RO_4x3: ro_svg_2.default,
    RS_1x1: rs_svg_1.default,
    RS_4x3: rs_svg_2.default,
    RU_1x1: ru_svg_1.default,
    RU_4x3: ru_svg_2.default,
    RW_1x1: rw_svg_1.default,
    RW_4x3: rw_svg_2.default,
    SA_1x1: sa_svg_1.default,
    SA_4x3: sa_svg_2.default,
    SB_1x1: sb_svg_1.default,
    SB_4x3: sb_svg_2.default,
    SC_1x1: sc_svg_1.default,
    SC_4x3: sc_svg_2.default,
    SD_1x1: sd_svg_1.default,
    SD_4x3: sd_svg_2.default,
    SE_1x1: se_svg_1.default,
    SE_4x3: se_svg_2.default,
    SG_1x1: sg_svg_1.default,
    SG_4x3: sg_svg_2.default,
    SH_AC_1x1: sh_ac_svg_1.default,
    SH_AC_4x3: sh_ac_svg_2.default,
    SH_HL_1x1: sh_hl_svg_1.default,
    SH_HL_4x3: sh_hl_svg_2.default,
    SH_TA_1x1: sh_ta_svg_1.default,
    SH_TA_4x3: sh_ta_svg_2.default,
    SH_1x1: sh_svg_1.default,
    SH_4x3: sh_svg_2.default,
    SI_1x1: si_svg_1.default,
    SI_4x3: si_svg_2.default,
    SJ_1x1: sj_svg_1.default,
    SJ_4x3: sj_svg_2.default,
    SK_1x1: sk_svg_1.default,
    SK_4x3: sk_svg_2.default,
    SL_1x1: sl_svg_1.default,
    SL_4x3: sl_svg_2.default,
    SM_1x1: sm_svg_1.default,
    SM_4x3: sm_svg_2.default,
    SN_1x1: sn_svg_1.default,
    SN_4x3: sn_svg_2.default,
    SO_1x1: so_svg_1.default,
    SO_4x3: so_svg_2.default,
    SR_1x1: sr_svg_1.default,
    SR_4x3: sr_svg_2.default,
    SS_1x1: ss_svg_1.default,
    SS_4x3: ss_svg_2.default,
    ST_1x1: st_svg_1.default,
    ST_4x3: st_svg_2.default,
    SV_1x1: sv_svg_1.default,
    SV_4x3: sv_svg_2.default,
    SX_1x1: sx_svg_1.default,
    SX_4x3: sx_svg_2.default,
    SY_1x1: sy_svg_1.default,
    SY_4x3: sy_svg_2.default,
    SZ_1x1: sz_svg_1.default,
    SZ_4x3: sz_svg_2.default,
    TC_1x1: tc_svg_1.default,
    TC_4x3: tc_svg_2.default,
    TD_1x1: td_svg_1.default,
    TD_4x3: td_svg_2.default,
    TF_1x1: tf_svg_1.default,
    TF_4x3: tf_svg_2.default,
    TG_1x1: tg_svg_1.default,
    TG_4x3: tg_svg_2.default,
    TH_1x1: th_svg_1.default,
    TH_4x3: th_svg_2.default,
    TJ_1x1: tj_svg_1.default,
    TJ_4x3: tj_svg_2.default,
    TK_1x1: tk_svg_1.default,
    TK_4x3: tk_svg_2.default,
    TL_1x1: tl_svg_1.default,
    TL_4x3: tl_svg_2.default,
    TM_1x1: tm_svg_1.default,
    TM_4x3: tm_svg_2.default,
    TN_1x1: tn_svg_1.default,
    TN_4x3: tn_svg_2.default,
    TO_1x1: to_svg_1.default,
    TO_4x3: to_svg_2.default,
    TR_1x1: tr_svg_1.default,
    TR_4x3: tr_svg_2.default,
    TT_1x1: tt_svg_1.default,
    TT_4x3: tt_svg_2.default,
    TV_1x1: tv_svg_1.default,
    TV_4x3: tv_svg_2.default,
    TW_1x1: tw_svg_1.default,
    TW_4x3: tw_svg_2.default,
    TZ_1x1: tz_svg_1.default,
    TZ_4x3: tz_svg_2.default,
    UA_1x1: ua_svg_1.default,
    UA_4x3: ua_svg_2.default,
    UG_1x1: ug_svg_1.default,
    UG_4x3: ug_svg_2.default,
    UM_1x1: um_svg_1.default,
    UM_4x3: um_svg_2.default,
    UN_1x1: un_svg_1.default,
    UN_4x3: un_svg_2.default,
    US_1x1: us_svg_1.default,
    US_4x3: us_svg_2.default,
    UY_1x1: uy_svg_1.default,
    UY_4x3: uy_svg_2.default,
    UZ_1x1: uz_svg_1.default,
    UZ_4x3: uz_svg_2.default,
    VA_1x1: va_svg_1.default,
    VA_4x3: va_svg_2.default,
    VC_1x1: vc_svg_1.default,
    VC_4x3: vc_svg_2.default,
    VE_1x1: ve_svg_1.default,
    VE_4x3: ve_svg_2.default,
    VG_1x1: vg_svg_1.default,
    VG_4x3: vg_svg_2.default,
    VI_1x1: vi_svg_1.default,
    VI_4x3: vi_svg_2.default,
    VN_1x1: vn_svg_1.default,
    VN_4x3: vn_svg_2.default,
    VU_1x1: vu_svg_1.default,
    VU_4x3: vu_svg_2.default,
    WF_1x1: wf_svg_1.default,
    WF_4x3: wf_svg_2.default,
    WS_1x1: ws_svg_1.default,
    WS_4x3: ws_svg_2.default,
    XK_1x1: xk_svg_1.default,
    XK_4x3: xk_svg_2.default,
    XX_1x1: xx_svg_1.default,
    XX_4x3: xx_svg_2.default,
    YE_1x1: ye_svg_1.default,
    YE_4x3: ye_svg_2.default,
    YT_1x1: yt_svg_1.default,
    YT_4x3: yt_svg_2.default,
    ZA_1x1: za_svg_1.default,
    ZA_4x3: za_svg_2.default,
    ZM_1x1: zm_svg_1.default,
    ZM_4x3: zm_svg_2.default,
    ZW_1x1: zw_svg_1.default,
    ZW_4x3: zw_svg_2.default,
};
var Bandeiras = function (_a) {
    var Altura = _a.Altura, Largura = _a.Largura, _b = _a.bandeira, bandeira = _b === void 0 ? 'BR_4x3' : _b, className = _a.className, style = _a.style;
    var ComponenteBandeira = bandeira ? exports.dicionarioBandeiras[bandeira] : '';
    if (!ComponenteBandeira) {
        return null;
    }
    return react_1.default.createElement(ComponenteBandeira, { height: Altura, width: Largura, className: className, style: style });
};
exports.Bandeiras = Bandeiras;
